// extracted by mini-css-extract-plugin
module.exports = {"root":"📦TagOutsideCustomerWarning__root--lip6M","dim":"📦TagOutsideCustomerWarning__dim--Q0quI","bigIcon":"📦TagOutsideCustomerWarning__bigIcon--w9Xx-"};